import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsAutomationRoute: InvariantJiraRoute = {
	name: 'project-settings-automation',
	path: '/jira/software/projects/:projectKey/settings/automate',
};
